import { ButtonPrimaryTextOnly, ButtonPrimaryTextOnlyProps, Box } from '@creditas-ui/react';

type ButtonType = 'submit' | 'button' | 'reset' | undefined;

export type ContinueButtonProps = Omit<ButtonPrimaryTextOnlyProps, 'children'> & {
  type?: ButtonType;
  text?: string;
};

export const ContinueButton = ({
  loading = false,
  disabled = false,
  type = 'submit',
  text = 'Continuar',
  onClick,
  ...props
}: ContinueButtonProps): JSX.Element => (
  <Box display="flex">
    <ButtonPrimaryTextOnly
      {...props}
      type={type}
      size="large"
      width="flexible"
      flex={1}
      loading={loading}
      disabled={disabled}
      onClick={onClick}
    >
      {text}
    </ButtonPrimaryTextOnly>
  </Box>
);
